import { HomeCareLeadId } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { stableQueryOptionsRpc } from "util/requests";

export interface HomeCareLeadAiSummaryAccess {
    canManage: boolean;
}

export const useHomeCareLeadAiSummaryAccessQuery = (
    homeCareLeadId: HomeCareLeadId | null,
) => {
    const trpcClient = trpc.useTRPC();

    return useQuery({
        ...trpcClient.homeCareLeadAiSummary.access.queryOptions({
            entityId: homeCareLeadId!,
        }),
        ...stableQueryOptionsRpc(),
        enabled: homeCareLeadId !== null,
    });
};

export const useHomeCareLeadAiSummaryAccess = (
    homeCareLeadId: HomeCareLeadId | null,
): HomeCareLeadAiSummaryAccess => {
    const accessQuery = useHomeCareLeadAiSummaryAccessQuery(homeCareLeadId);

    return { canManage: accessQuery.data?.canManage ?? false };
};
